import React from 'react';

const EIKON_URL =
  process.env.REACT_APP_EIKON_URL ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:8765/'
    : '/eikon/');

export default function Eikon() {
  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
        background: '#0b0d10',
        overflow: 'hidden',
      }}
    >
      <iframe
        title="Eikon · relation knowledge graph"
        src={EIKON_URL}
        style={{
          width: '100%',
          height: '100%',
          border: 0,
          display: 'block',
        }}
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
}
